import { useCallback, useEffect, useState } from 'react';
import { ManagerMeetingsLensButton } from '../../apps/meetings/components/meeting-top-buttons/ManagerMeetingsLensButton';
import { useTranslation } from 'react-i18next';

type ToastEvent = {
  toastType: 'success' | 'error',
  message: string;
  error: Error;
};

type ManagerProps = {
  id: string;
  fullName: string;
  picture: string;
  isReadOnly: boolean;
};

type ProfileManagerLensProps = {
  userId: number;
  manager: ManagerProps;
  isDirectManager: boolean;
}

export const ProfileManagerLens = ({ userId, manager, isDirectManager }: ProfileManagerLensProps) => {
  const { t } = useTranslation();
  const title = isDirectManager ? t("Manager's Lens") : t('Coach on Call');
  const isUserLensEnabled = window.wbConfig?.isUserLensEnabled ?? false;
  const isManagerLensEnabled = window.wbConfig?.isManagerLensEnabled ?? false;
  const isShowManagerLens = ((userId && manager?.id) && (isUserLensEnabled || (isDirectManager && isManagerLensEnabled)));

  const [openCount, setOpenCount] = useState<number>(0);

  const onToast = (e) => {
    const event = e as ToastEvent;
    if (event.toastType === 'error') {
      console.error(event.error);
    }
    toastr?.[event.toastType]?.(event.message);
  };

  const openManagerLens = useCallback(
    () => {
      if (isShowManagerLens) {
        window.initManagerLensComponent(
          'profile-manager-lens',
          {
            userId,
            manager,
            isReadonly: false,
            location: 'PROFILE_PAGE',
            title,
            onToast,
            hideFixedTrigger: true,
            hideStaticTrigger: false,
            staticTriggerElement: (onClick) => (
              <ManagerMeetingsLensButton title={title} onClick={onClick} />
            ),
          },
        );
        setTimeout(() => {
          setOpenCount((prev) => prev + 1);
        }, 200);
      }
    }, [userId, manager, isShowManagerLens, setOpenCount]);

  useEffect(() => {
    if (openCount == 1) {
      // should trigger initial load of the manager lens component.
      const buttonElement = document.querySelector('#profile-manager-lens .meetings-lens-button') as HTMLButtonElement;
      if (buttonElement) {
        buttonElement.click();
      }
    }
  }, [openCount]);

  return (
    <div id="profile-manager-lens">
      {isShowManagerLens && (<ManagerMeetingsLensButton title={title} onClick={openManagerLens} />)}
    </div>
  );
}